import { Subject, debounceTime } from 'rxjs';
import { CoordinatorService, MANIFEST_STORE_DELAY } from './coordinator.service';

export class Pin {
    id: string;
    private _tagSet = new Set<string>();
    // refresh$ = new Subject<void>()

    private _markForManifestStoreSubject$ = new Subject<void>();
    private _markForManifestStore$ = this._markForManifestStoreSubject$.pipe(
        debounceTime(MANIFEST_STORE_DELAY),
    );

    constructor(
        private coords: CoordinatorService,
        params: { id: string },
    ) {
        this.id = params.id;

        this._markForManifestStore$.subscribe(() => this._manifestStore());
    }

    init(ls: string[]) {
        if (ls) this._tagSet = new Set(ls);
    }
    markForManifestStore() {
        this._markForManifestStoreSubject$.next();
    }

    private _manifestStore() {
        this.coords.manifest$.store({
            type: 'pin',
            id: this.id,
            valueMap: new Map<string, any[]>([['tagLs', Array.from(this._tagSet)]]),
        });
    }

    private _refresh() {
        this.coords.pin$.markForCheck$.next();
        this.coords.display$.markForCheck();
        this.markForManifestStore();
    }

    update(tagLs: string[]) {
        this._tagSet = new Set(tagLs);
    }

    on(tag: string) {
        if (this._tagSet.has(tag)) return;
        this._tagSet.add(tag);
        this._refresh();
        // console.log('ON PIN', tag);
    }

    off(tag: string) {
        if (!this._tagSet.has(tag)) return;
        this._tagSet.delete(tag);
        this._refresh();
        // console.log('OFF PIN', tag);
    }

    switch(tag: string) {
        let r: boolean;
        if (this._tagSet.delete(tag)) r = false;
        else {
            this._tagSet.add(tag);
            r = true;
        }
        this._refresh();
        // console.log('SWITCH PIN', tag);
        return r;
    }

    has(tag: string) {
        return this._tagSet.has(tag);
    }

    batch(tagLs: string[], value: boolean) {
        tagLs.forEach((tag) => (value ? this._tagSet.add(tag) : this._tagSet.delete(tag)));
        this._refresh();
    }
}
